export const isBotRequest = (userAgent: string | null): boolean => {
  if (!userAgent) return false

  const botPatterns = [
    /bot/i,
    /crawler/i,
    /spider/i,
    /googlebot/i,
    /bingbot/i,
    /yandex/i,
    /baidu/i,
    /slurp/i,
    /duckduckgo/i,
    /facebookexternalhit/i,
    /whatsapp/i,
    /telegram/i,
    /twitterbot/i,
    /linkedinbot/i,
  ]

  return botPatterns.some((pattern) => pattern.test(userAgent))
}

export const isLighthouseTest = () => {
  if (typeof window === 'undefined') return true

  return (
    window.navigator.userAgent.includes('Chrome-Lighthouse') ||
    window.navigator.userAgent.includes('PageSpeed') ||
    window.navigator.userAgent.includes('Lighthouse') ||
    // Check for Lighthouse testing environment variables
    window.location.search.includes('lighthouse=true')
  )
}
